import {text_field_change} from "../../redux/actions";
import React from "react";
import {useDispatch, useSelector} from "react-redux";

export const UserEmail = () => {
    const dispatch = useDispatch()
    const value = useSelector(state => state.app.requestUserEmail)
    const error = useSelector(state => state.app.requestUserEmailError)
    return (
        <React.Fragment>
            <label className="request-popup__label" htmlFor="city_from">E-mail</label>
            <input type="email" id="user_email"
                   className={'text-input' + (error ? ' error' : '')}
                   name="user_email" placeholder=""
                   value={value}
                   onChange={(e) => dispatch(text_field_change('user_email', e.target.value))}
            />
        </React.Fragment>
    )
}